// src/api.js
import axios from 'axios';

// Base URL of the backend
// const BASE_URL = "/GOH_WS_NEW/Service1.svc";
// const BASE_URL = "/GOH_WS_TEST/Service1.svc";



 //const BASE_URL = "http://199.203.140.245:44380/GOH_WS_TEST/Service1.svc";
  
 //const BASE_URL = "http://localhost:62638/Service1.svc";

const BASE_URL = "https://backendgoh.gms-web.co.il/GOH_WS_TEST_SECURE/Service1.svc";


export const fetchCatalog = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/GetCatalog`);
    return response.data;
  } catch (error) {
    console.error('Error fetching catalog:', error);
    return null;
  }
};

// Function to login and fetch user warehouses
export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/Login`, {
      UserName: username,
      Password: password,
    }, {
      withCredentials: true // << THIS IS THE MISSING PIECE
    });
    return response.data;
  } catch (error) {
    console.error('Login API Error:', error.response || error.message);
    return null;
  }
};


export const fetchInventory = async (storeCode, custCode) => {
    try {
      const response = await axios.post(`${BASE_URL}/GetInventory`, {
        Store_Code: storeCode,
        Cust_Code: custCode,
      }, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching inventory:', error);
      return [];
    }
  };

// Open exported boats of the logged-in customer (parent + children).
// Returned even when they have zero stock (a new export boat starts empty).
export const fetchExportedStores = async (custCode) => {
  try {
    const response = await axios.post(`${BASE_URL}/GetExportedStoresByCust`, {
      Cust_Code: custCode,
    }, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error('Error fetching exported stores:', error);
    return [];
  }
};

export const fetchCustomerMovements = async (custCode, fromDate, toDate) => {
  try {
    const response = await axios.post(`${BASE_URL}/GetDocsToManagerByCustCodeFiltered`, {
      Cust_Code: custCode,
      FromDate: fromDate,
      ToDate: toDate
    }, { withCredentials: true });
    return response.data;
  } catch (err) {
    console.error("Error fetching filtered docs:", err);
    return [];
  }
};
  
